<template>
  <small-modal
    :title="modalTitle"
    class="add-title-modal"
    :fit-content="true"
    @close="close"
  >
    <div class="default-colors-picker-modal-container">
      <h2>{{ $t("account.userInformation.setDefaultColors.subtitle") }}</h2>
      <banner-modal
        class="banner-modal"
        :title="$t('deleteCampaign.information')"
        :text="bannerText"
      >
      </banner-modal>
      <div class="settings">
        <div class="setting">
          <div class="color-buttons">
            <input v-model="mainColorValue" class="color-code" maxlength="7" />
            <button
              class="value-color"
              :style="`background-color: ${mainColorValue || '#7B01B5'}`"
              @click="showPicker('main')"
            />
          </div>
          <p>{{ $t("account.userInformation.setDefaultColors.mainButton") }}</p>
        </div>
        <div class="setting">
          <div class="color-buttons">
            <input v-model="textColorValue" class="color-code" maxlength="7" />
            <button
              class="value-color"
              :style="`background-color: ${textColorValue || '#FFFFFF'}`"
              @click="showPicker('text')"
            />
          </div>
          <p>{{ $t("account.userInformation.setDefaultColors.textButton") }}</p>
        </div>
      </div>
      <div
        v-if="displayPicker"
        key="color-picker"
        v-click-outside="hidePicker"
        class="vidjet-color-picker"
      >
        <color-picker :value="currentColor" @input="onPickerChange" />
      </div>
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal";
import BannerModal from "@/components/shared/BannerModal.vue";
import { Chrome } from "vue-color";
import { mapState } from "vuex";

export default {
  components: {
    SmallModal,
    BannerModal,
    colorPicker: Chrome,
  },

  data() {
    return {
      mainColorValue: "#7B01B5",
      textColorValue: "#FFFFFF",
      displayPicker: false,
      pickerType: "",
    };
  },
  computed: {
    ...mapState(["site"]),
    modalTitle() {
      return this.$t("account.userInformation.setDefaultColors.title");
    },
    bannerText() {
      return this.$t("account.userInformation.setDefaultColors.banner");
    },
    currentColor() {
      return this.pickerType === "main"
        ? this.mainColorValue
        : this.textColorValue;
    },
  },
  async created() {
    await this.$store.dispatch("plan/getPlan", {
      siteId: this.$store.state.account.user.siteId,
    });
    this.mainColorValue = this.site.site.mainColor || "#7B01B5";
    this.textColorValue = this.site.site.textColor || "#FFFFFF";
  },
  methods: {
    close() {
      this.$emit("close");
    },
    showPicker(type) {
      this.pickerType = type;
      this.displayPicker = true;
    },

    hidePicker() {
      this.displayPicker = false;
    },

    onPickerChange(color) {
      const hex = color.hex;
      if (this.pickerType === "main") {
        this.mainColorValue = hex;
        this.updateSiteColor("mainColor", hex);
      } else {
        this.textColorValue = hex;
        this.updateSiteColor("textColor", hex);
      }
    },

    async updateSiteColor(key, value) {
      try {
        await this.$store.dispatch("site/updateSite", {
          siteId: this.site.site._id,
          dataToUpdate: { [key]: value },
        });
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-modal {
  margin-bottom: 24px;
  min-width: 480px;
}
.default-colors-picker-modal-container h2 {
  text-align: center;
  margin-bottom: 24px;
  font-weight: 400;
}
.settings {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
}

.setting {
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-code {
  border: 1px solid $medium-grey;
  padding: 8px 16px;
  background: transparent;
  @include base-font;
  @include font-smaller;
  color: $medium-grey;
  border-radius: 2px;
  outline: none;
  width: 90px;
  box-sizing: border-box;
}

.value-color {
  width: 24px;
  height: 24px;
  border: none;
  cursor: pointer;
}

.vidjet-color-picker {
  position: absolute;
  z-index: 1000;
}
</style>
